import {
  ActivityTrailMapped,
  ParticipationDataSchema,
  ProjectDataSchema,
  SessionDataSchema,
} from '@fe-learner-common';
import { localizedErrorHandlers } from '@fe-core/api';
import wretch from 'wretch';
import * as v from 'valibot';
const delayPromise = new Promise((resolve) => setTimeout(resolve, 800));
export const ParticipationSchema = v.object({
  participation: ParticipationDataSchema,
  trail: ActivityTrailMapped,
  session: v.optional({ ...SessionDataSchema }),
  project: ProjectDataSchema,
});

export type TParticipationResponseData = v.Output<typeof ParticipationSchema>;

export const getParticipationData = async (
  baseUrl: string,
  participationId: string,
): Promise<TParticipationResponseData> => {
  const url = `${baseUrl}/participations/${participationId}`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  const dataPromise = localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(ParticipationSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-common | getParticipationData | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid participation response');
    }
  });

  const [result, _] = await Promise.all([dataPromise, delayPromise]);
  return result;
};
